// Production Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://server.acpca.net/api';
export const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 
  (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net');

// Helper function to get full image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If starts with /, use it directly
  if (imagePath.startsWith('/')) {
    return `${IMAGE_BASE_URL}${imagePath}`;
  }
  
  // Otherwise, prepend /
  return `${IMAGE_BASE_URL}/${imagePath}`;
};

// Helper function to get API URL
export const getApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${cleanEndpoint}`;
};

// Helper to construct image URL from upload response
export const getUploadedImageUrl = (uploadResponseUrl) => {
  if (!uploadResponseUrl) return '';
  if (uploadResponseUrl.startsWith('http://') || uploadResponseUrl.startsWith('https://')) {
    return uploadResponseUrl;
  }
  return `${IMAGE_BASE_URL}${uploadResponseUrl.startsWith('/') ? uploadResponseUrl : `/${uploadResponseUrl}`}`;
};

